//
export const tabsData = [
  {
    title: "Комплекс",
    text: "Комплекс расположен в 40 метрах от моря в центре Адлерского района, из окон открываются непревзойденные виды на морской горизонт.",
    images: [
      "img/1/gorizont-1.jpg",
      "img/1/gorizont-2.jpg",
      "img/1/gorizont-3.jpg",
      "img/1/gorizont-4.jpg",
      "img/1/gorizont-5.jpg",
      "img/1/gorizont-6.jpg",
      "img/1/gorizont-7.jpg",
      "img/1/gorizont-8.jpg",
      "img/1/gorizont-9.jpg",
      "img/1/gorizont-10.jpg",
      "img/1/gorizont-11.jpg",
      "img/1/gorizont-12.jpg",
    ],
  },
  {
    title: "ОТДЕЛКА",
    text: "Комплекс расположен в 40 метрах от моря в центре Адлерского района, из окон открываются непревзойденные виды на морской горизонт.",
    images: [
      "img/2/hall-1.jpg",
      "img/2/hall-2.jpg",
      "img/2/hall-3.jpg",
      "img/2/hall-4.jpg",
    ],
  },
  {
    title: "Пляжи",
    text: "Комплекс расположен в 40 метрах от моря в центре Адлерского района, из окон открываются непревзойденные виды на морской горизонт.",
    images: [
      "img/1/gorizont-1.jpg",
      "img/1/gorizont-2.jpg",
      "img/1/gorizont-3.jpg",
      "img/1/gorizont-4.jpg",
      "img/1/gorizont-5.jpg",
      "img/1/gorizont-6.jpg",
      "img/1/gorizont-7.jpg",
      "img/1/gorizont-8.jpg",
      "img/1/gorizont-9.jpg",
      "img/1/gorizont-10.jpg",
      "img/1/gorizont-11.jpg",
      "img/1/gorizont-12.jpg",
    ],
  },
  {
    title: "Туристический центр",
    text: "Комплекс расположен в 40 метрах от моря в центре Адлерского района, из окон открываются непревзойденные виды на морской горизонт.",
    images: [
      "img/2/hall-1.jpg",
      "img/2/hall-2.jpg",
      "img/2/hall-3.jpg",
      "img/2/hall-4.jpg",
    ],
  },
  {
    title: "Рестораны и кафе",
    text: "Комплекс расположен в 40 метрах от моря в центре Адлерского района, из окон открываются непревзойденные виды на морской горизонт.",
    images: [
      "img/2/hall-1.jpg",
      "img/2/hall-2.jpg",
      "img/2/hall-3.jpg",
      "img/2/hall-4.jpg",
    ],
  },
  {
    title: "Бары и клубы",
    text: "Комплекс расположен в 40 метрах от моря в центре Адлерского района, из окон открываются непревзойденные виды на морской горизонт.",
    images: [
      "img/2/hall-1.jpg",
      "img/2/hall-2.jpg",
      "img/2/hall-3.jpg",
      "img/2/hall-4.jpg",
    ],
  },
  {
    title: "ТЦ и финансы",
    text: "Комплекс расположен в 40 метрах от моря в центре Адлерского района, из окон открываются непревзойденные виды на морской горизонт.",
    images: [
      "img/2/hall-1.jpg",
      "img/2/hall-2.jpg",
      "img/2/hall-3.jpg",
      "img/2/hall-4.jpg",
    ],
  },
  {
    title: "Школы и д/с",
    text: "Комплекс расположен в 40 метрах от моря в центре Адлерского района, из окон открываются непревзойденные виды на морской горизонт.",
    images: [
      "img/2/hall-1.jpg",
      "img/2/hall-2.jpg",
      "img/2/hall-3.jpg",
      "img/2/hall-4.jpg",
    ],
  },
  {
    title: "Соц. инфраструктура",
    text: "Комплекс расположен в 40 метрах от моря в центре Адлерского района, из окон открываются непревзойденные виды на морской горизонт.",
    images: [
      "img/2/hall-1.jpg",
      "img/2/hall-2.jpg",
      "img/2/hall-3.jpg",
      "img/2/hall-4.jpg",
    ],
  },
  {
    title: "Красота и здоровье",
    text: "Комплекс расположен в 40 метрах от моря в центре Адлерского района, из окон открываются непревзойденные виды на морской горизонт.",
    images: [
      "img/2/hall-1.jpg",
      "img/2/hall-2.jpg",
      "img/2/hall-3.jpg",
      "img/2/hall-4.jpg",
    ],
  },
  {
    title: "Супермаркеты",
    text: "Комплекс расположен в 40 метрах от моря в центре Адлерского района, из окон открываются непревзойденные виды на морской горизонт.",
    images: [
      "img/2/hall-1.jpg",
      "img/2/hall-2.jpg",
      "img/2/hall-3.jpg",
      "img/2/hall-4.jpg",
    ],
  },
];
